// left sidde belongs to kpi we get from api and right side for front end and we are using front end side for piecharts

export const labelToValueMapping: labelToValueType = {
  "Total order value": "Total Order Value",
  "Total order value by cross sell": "Total Order Value by Cross Sell",
  "Incremental order value by upsell": "Incremental Order Value by Upsell",
  "SKU impact of cross sell": "Cross Sell SKU Impact %",
  "Outlet impact of cross sell": "Cross Sell Outlet Impacted %",
  "First time order value by cross sell":
    "Cross sell value(single time achievement)",
  "Repeated order value by cross sell":
    "Cross sell value(multiple-time achievement)",
  "Cross sell as a %age of total order": "Cross Sell Business contribution %",
  "Cross sell Compliance": "Cross Sell SKU Compliance",
  "Outlet impact of Upsell": "Upsell Outlet impacted %",
  "Upsell Compliance": "Upsell SKU Compliance",
  "Upsell as a %age of total order": "Upsell Business contribution %",
  "Total Regular value order":"Total Regular value order",
  "SKU impact of Upsell":"SKU impact of Upsell",
};

type labelToValueType = {
  [key: string]: string;
};

export const crossSellOptions = [
  "Cross Sell SKU Impact %",
  "Cross Sell Outlet Impacted %",
  "Cross sell value(single time achievement)",
  "Cross sell value(multiple-time achievement)",
];

export const recommendationComplians = [
  "Cross Sell Business contribution %",
  "Cross Sell SKU Compliance",
];

export const upSellOptions = [
  "Upsell Outlet impacted %",
  "Upsell SKU Compliance",
  "Upsell Business contribution %",
];

export const focusSellOptions = [
  "Focus Value",
  "Focus SKU Compliance",
  "Focus Outlet Impacted",
];

export const block1 = ["Total Order Value", "Total Outlets", "Total skus"];

export const block2 = [
  "Total Order Value by Cross Sell",
  "Incremental Order Value by Upsell",
];

export const PieChart2 = [
  {
    label: "Cross sell value(multiple-time achievement)",
    name: "Repeat Sales",
    fill: "#00c6b2",
  },
  {
    label: "Cross sell value(single time achievement)",
    name: "First time",
    fill: "#1c7ea0",
  },
];

export const PieChart1 = [
  {label:"Total Order Value by Cross Sell", name: "Cross Sell", fill: "#00c6b2" },
  {label:"Incremental Order Value by Upsell", name: "Upsell", fill: "#2d5f98" },
  {label:"Total Regular value order", name: "Regular", fill: "#2c8bba" },
];

export const PieChart3 =[
    {
      label:"SKU impact of Upsell",
      name:"Upsell-SKU",
      fill:"#1c7ea0"
    },{
      label:"Upsell Outlet impacted %",
      name:"Upsell-Outlet",
      fill:"#1c7ea0"
    },{
      label:"Cross Sell SKU Impact %",
      name:"CrossSell-SKU",
      fill:"#1c7ea0"
    },
    {
      label:"Cross Sell Outlet Impacted %",
      name:"CrossSell-Outlet",
      fill:"#1c7ea0"
    }
]
